import { render, staticRenderFns } from "./commList.vue?vue&type=template&id=29c13f70&scoped=true"
import script from "./commList.vue?vue&type=script&lang=js"
export * from "./commList.vue?vue&type=script&lang=js"
import style0 from "./commList.vue?vue&type=style&index=0&id=29c13f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c13f70",
  null
  
)

export default component.exports